module.exports = __webpack_public_path__ + "img/logo.c32c41b7.png";